import { AccountGroup } from "@common/types/domains/accounting/account";
import { DraftGroup } from "../draftState";

// Adapts the editor's draft groups to the AccountGroup shape GroupTreeSelectField
// (buildPredefinedTree / buildGroupTree / buildGroupPathSegments) expects. Those
// readers only touch id/name/type/parentGroupId.
export const draftGroupsToAccountGroups = (
    groups: DraftGroup[],
): AccountGroup[] =>
    groups.map((group) => ({
        id: group.id,
        entityId: group.entityId,
        name: group.name,
        type: group.type,
        parentGroupId: group.parentGroupId,
        sortOrder: group.sortOrder,
    }));
